"use strict";

const $ = require("./main.js");
$(document).ready(function () {
//----------------------------------------------------------------------------
//investors
//----------------------------------------------------------------------------
    $(document).on('click', 'body', function (e) {
        if ($(e.target).closest('.js-filter-item').length !== 1) {
            $('.js-investor-toggle-button').removeClass('active');
            $('.js-investor-toggle-target').removeClass('active');
        }
    });

    $(document).on('click', '.js-investor-toggle-button', function (e) {
        $('.js-investor-toggle-button').not(this).removeClass('active');
        $(this).toggleClass('active');

        $('.js-investor-toggle-target').removeClass('active');
        if ($(this).hasClass('active')) {
            $($(this).data('target')).addClass('active');
        }

        return false;
    });

    $(document).on('change', '.js-investor-form-option', function (e) {
        var query = $('.js-investor-form').serialize();
        history.pushState(null, null, location.pathname + (query ? '?' + $('.js-investor-form').serialize() : ''));
        queryData();
    });

    $(document).on('click', '.js-investor-form-tag', function (e) {
        var id = $(this).data('id');
        $('#' + id).prop("checked", false);
        var query = $('.js-investor-form').serialize();
        history.pushState(null, null, location.pathname + (query ? '?' + $('.js-investor-form').serialize() : ''));
        queryData();
    });

});

function queryData() {
    $.ajax({
        type: 'GET',
        url: '/investors/results-and-reports/filter' + location.search,
        success: function (data) {
            render(data)
        }
    });
};

function render(data) {
    if ($('.js-list-reset').length == 0) {
        $('.js-investor-form').after('<ul class="js-list-reset"></ul>')
    }

    if (data.filters.length > 0) {
        $('.js-list-reset').replaceWith(data.tagsHtml);
    } else {
        $('.js-list-reset').remove();
    }

    $('.js-filter-count__number').text(data.reports.length + ' ' + (data.reports.length == 1 ? 'report' : 'reports'))
    $('.js-report-list-view-items').html(data.reportsHtml);
    initLazyLoad();

};